import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-14 px-4 bg-black" data-id="element-88">
      <div className="max-w-2xl mx-auto" data-id="element-89">
        <div className="bg-gradient-to-br from-zinc-900 to-zinc-950 border-2 border-brand-green rounded-2xl p-6 md:p-10 text-center shadow-2xl glow-green" data-id="element-90">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-brand-green rounded-full mb-4 shadow-lg border-4 border-white/10 ring-4 ring-brand-green/30" data-id="element-91">
            <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-92" />
          </div>

          <h2 className="text-2xl md:text-4xl font-display font-bold mb-4 text-white uppercase leading-tight" data-id="element-93">
            🛡️ Garantía 7 Días <br data-id="element-94" />
            <span className="text-brand-greenLight" data-id="element-95">— Sin Riesgo</span>
          </h2>

          <p className="text-sm md:text-base text-zinc-200 leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-96">
            Si en <span className="highlight-green font-bold" data-id="element-97">7 días</span>{' '}
            sentís que este sistema no te ayuda a mejorar la organización y el
            manejo de tu campo, simplemente escribinos y te devolvemos el{' '}
            <span className="highlight-yellow font-bold" data-id="element-98">
              100% de tu dinero
            </span>
            .
          </p>

          <p className="text-lg md:text-2xl font-display font-bold text-brand-greenLight uppercase" data-id="element-99">
            Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}